import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router)

export function loadView (view) {
  return () => import(
    /* webpackMode: "lazy" */
    /* webpackPrefetch: true */
    `@/views/${view}`
  )
}

export default new Router({
  base: '/',
  routes
})
